export function getQueryParam(query: string): string {
  try {
    const params = new URLSearchParams(window.location.search);
    return params.get(query);
  } catch (error) {
    return null;
  }
}
